module.exports = __webpack_public_path__ + "static/media/comments-icon.ec5408aa.svg";